// services/api.js
import axios from 'axios';

const API_BASE_URL = 'https://digital-signature-api-14df.onrender.com/reiman'; // API BASE URL
//const API_BASE_URL = 'http://127.0.0.1:8000/reiman'; // API BASE URL

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const apiKey = localStorage.getItem('apiKey');
    if (apiKey) {
      config.headers['X-API-Key'] = apiKey;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;